const categoriesData = [
  {
    title: "Development",
    subcategories: [
      {
        title: "Web Development",
        popularTopics: [
          "JavaScript", "React", "HTML/CSS", "MERN", "TypeScript", "Node.js", "Angular", "Vue.js", "Svelte"
        ]
      },
      {
        title: "Mobile Development",
        popularTopics: [
          "Flutter", "React Native", "Swift", "Kotlin", "Android Studio", "iOS Development", "Xamarin", "Ionic"
        ]
      },
      {
        title: "Programming Languages",
        popularTopics: [
          "Python", "Java", "C++", "JavaScript", "Go", "Ruby", "Rust", "Swift", "C#", "PHP"
        ]
      },
      {
        title: "Game Development",
        popularTopics: [
          "Unity", "Unreal Engine", "C#", "Game Design", "3D Modeling", "AR/VR Development", "Blender", "Godot"
        ]
      },
      {
        title: "Database Design & Development",
        popularTopics: [
          "SQL", "MongoDB", "PostgreSQL", "Firebase", "Database Architecture", "NoSQL", "GraphQL", "Cassandra"
        ]
      },
      {
        title: "Software Testing",
        popularTopics: [
          "Selenium", "Unit Testing", "Test Automation", "API Testing", "JUnit", "Cucumber", "Cypress", "Appium"
        ]
      },
      {
        title: "Software Engineering",
        popularTopics: [
          "Software Design Patterns", "Microservices", "DevOps", "Systems Architecture", "Agile", "Scrum", "CI/CD"
        ]
      },
      {
        title: "Software Development Tools",
        popularTopics: [
          "Git", "Docker", "Kubernetes", "Jenkins", "CI/CD", "IDEs", "Terraform", "Vagrant", "GitLab"
        ]
      },
      {
        title: "No-Code Development",
        popularTopics: [
          "Webflow", "Bubble", "Adalo", "Zapier", "Airtable", "Integromat", "Glide", "Thunkable"
        ]
      }
    ]
  },
  {
    title: "Business",
    subcategories: [
      {
        title: "Entrepreneurship",
        popularTopics: [
          "Startups", "Funding", "Business Models", "Product Management", "Lean Startup", "Pitching", "Scaling"
        ]
      },
      {
        title: "Sales",
        popularTopics: [
          "B2B Sales", "Negotiation", "Lead Generation", "CRM", "Sales Funnels", "Cold Calling", "Email Marketing"
        ]
      },
      {
        title: "Leadership & Management",
        popularTopics: [
          "Team Management", "Leadership Skills", "Agile Leadership", "Strategic Thinking", "Project Management", "OKRs"
        ]
      },
      {
        title: "Business Analytics",
        popularTopics: [
          "Data Analysis", "Power BI", "Tableau", "Financial Modeling", "Business Intelligence", "Data Visualization", "Excel"
        ]
      }
    ]
  },
  {
    title: "Finance & Accounting",
    subcategories: [
      {
        title: "Financial Accounting",
        popularTopics: [
          "Balance Sheets", "Income Statements", "GAAP", "IFRS", "Auditing", "Bookkeeping", "Taxation", "QuickBooks"
        ]
      },
      {
        title: "Corporate Finance",
        popularTopics: [
          "Capital Budgeting", "Corporate Valuation", "Risk Management", "Mergers & Acquisitions", "Investment Banking", "IPO"
        ]
      },
      {
        title: "Personal Finance",
        popularTopics: [
          "Budgeting", "Saving", "Investing", "Retirement Planning", "Financial Independence", "Real Estate", "Stocks"
        ]
      }
    ]
  },
  {
    title: "IT & Software",
    subcategories: [
      {
        title: "Cloud Computing",
        popularTopics: [
          "AWS", "Azure", "Google Cloud", "Kubernetes", "Serverless Architecture", "Cloud Security", "DevOps", "OpenShift"
        ]
      },
      {
        title: "Cybersecurity",
        popularTopics: [
          "Ethical Hacking", "Penetration Testing", "Network Security", "Cryptography", "Cyber Threats", "Firewalls", "SOC"
        ]
      },
      {
        title: "Networking",
        popularTopics: [
          "CCNA", "Network Protocols", "Cisco", "SDN", "Network Security", "Routing", "VPN", "Switching"
        ]
      }
    ]
  },
  {
    title: "Design",
    subcategories: [
      {
        title: "Graphic Design",
        popularTopics: [
          "Photoshop", "Illustrator", "InDesign", "Canva", "Typography", "Color Theory", "Logo Design", "Branding"
        ]
      },
      {
        title: "UI/UX Design",
        popularTopics: [
          "Figma", "Adobe XD", "Sketch", "Wireframing", "Prototyping", "User Research", "Usability Testing"
        ]
      },
      {
        title: "3D & Animation",
        popularTopics: [
          "Blender", "Maya", "3ds Max", "Cinema 4D", "After Effects", "Motion Graphics", "Character Animation"
        ]
      }
    ]
  },
  {
    title: "Marketing",
    subcategories: [
      {
        title: "Digital Marketing",
        popularTopics: [
          "SEO", "Google Ads", "Facebook Ads", "Content Marketing", "Social Media Marketing", "PPC", "Influencer Marketing"
        ]
      },
      {
        title: "Affiliate Marketing",
        popularTopics: [
          "Affiliate Networks", "Commission Tracking", "Product Reviews", "SEO for Affiliates", "Email Campaigns"
        ]
      },
      {
        title: "Branding",
        popularTopics: [
          "Brand Strategy", "Brand Identity", "Brand Voice", "Customer Engagement", "Rebranding", "PR", "Storytelling"
        ]
      }
    ]
  },
  {
  title: "Business & Enterprise Software",
  subcategories: [
    {
      title: "ERP Systems",
      popularTopics: ["SAP", "Oracle ERP", "Microsoft Dynamics", "Workday", "NetSuite"]
    }
  ]
}

];

export default categoriesData;
